<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/userList/">Users</a></li>
      <li class="breadcrumb-item active" aria-current="page">Roles</li>
    </ol>
  </nav>
  <div class="row align-items-center">
    <div class="col mt-md-0 text-right float-right" style="height:34px;">
      <a class="ml-2" id="Roles">
        <img src="assets/images/create.png" routerLink="/admin/createRole"/>
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th>Role Code</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let r of rolesList;let i = index;">
            <td><a routerLink="/admin/editRole/{{r.roleId}}">{{r.roleName}}</a></td>
            <td>
              <div class="toggle-2">
                <input type="checkbox" name="onoffswitch" id="roleEnable-{{i}}" class="custom-control-input"
                       (change)="changeStatus(r)" [checked]="r.status==='ACTIVE'" class="checkbox"/>
                <label for="roleEnable-{{i}}" class="toggle">
                  <span>ON</span><span>OFF</span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="rolesList?.length===0|| !rolesList?.length">
            <td colspan="2" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Role Code</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr>

            <td>WORK_MEN</td>
            <td><b class=" tablesaw-cell-label">Role Code</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="customSwitch">
                <label class="custom-control-label"> </label>
              </div>
              </span></td>

          </tr>
          <tr>

            <td>DRIVER</td>
            <td>
              <b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="customSwitch">
                <label class="custom-control-label"> </label>
              </div>
              </span></td>

          </tr>
          </tbody>
        </table>


      </div>

    </div>
  </div>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right ">
      <button type="button" routerLink="/admin/userList" class="btn btn-cancel">Back</button>
    </div>
  </div>
</div>
